
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ParamFlag extends Vue {
  @Prop({ default: '' }) name!: string;
}
